module.exports = __webpack_public_path__ + "static/media/parents_slide_1_mobile.5301b3de.png";